// extracted by mini-css-extract-plugin
export default {"cart-Wigdet":"CartWidget_cart-Wigdet__nsI21","cart-wd-empty":"CartWidget_cart-wd-empty__E-x1C"};